import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { OpacityUpdater } from "./OpacityUpdater";
export function loadOpacityUpdater(_x) {
  return _loadOpacityUpdater.apply(this, arguments);
}

function _loadOpacityUpdater() {
  _loadOpacityUpdater = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var refresh,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            refresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            _context.next = 3;
            return engine.addParticleUpdater("opacity", function (container) {
              return new OpacityUpdater(container);
            }, refresh);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadOpacityUpdater.apply(this, arguments);
}